import { useEffect, useState } from 'react';
import type { VFC } from 'react';

import classNames from 'classnames';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import { Player } from '../Player/Player';
import { usePreviousValue } from '../utils/usePreviousValue';
import { AssetContainer } from '../AssetContainer/AssetContainer';
import { usePaywallState } from '../utils/usePaywallState';
import { PaywalledAssetSplash } from '../Splash/PaywalledAssetSplash/PaywalledAssetSplash';

import * as styles from './PlayerWithPaywalledDocumentaryDetails.module.scss';

interface PlayerWithPaywalledDocumentaryDetailsProps {
  asset: SvpAssetAdditional;
  startTime?: number;
}

const PlayerWithPaywalledDocumentaryDetails: VFC<
  PlayerWithPaywalledDocumentaryDetailsProps
> = ({ asset, startTime }) => {
  const [isPlayerCollapsed, setIsPlayerCollapsed] = useState(true);

  const previousAsset = usePreviousValue(asset);
  const { paywallState } = usePaywallState(asset);

  // reset the state when moving to a different asset
  useEffect(() => {
    if (asset.id !== previousAsset.id) {
      setIsPlayerCollapsed(true);
    }
  }, [asset, previousAsset]);

  return (
    <AssetContainer
      asset={asset}
      disableAssetBackground={isPlayerCollapsed}
      className={classNames(styles.container, {
        [styles.isPlayerCollapsed]: isPlayerCollapsed,
      })}
    >
      {(paywallState.isFetching || paywallState.hasAccess) &&
        !isPlayerCollapsed && (
          <Player
            asset={asset}
            className={styles.player}
            startTime={startTime}
          />
        )}
      <PaywalledAssetSplash asset={asset} />
    </AssetContainer>
  );
};

export { PlayerWithPaywalledDocumentaryDetails };
